import { render, staticRenderFns } from "./ViewResume.vue?vue&type=template&id=3791bb47"
import script from "./ViewResume.vue?vue&type=script&lang=js"
export * from "./ViewResume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports